import ReactGA from "react-ga4";
import Config from "../Config"
import { brushNames } from "../Splash/TypesAndConstants/Brushes"

export const initializeAnalytics = () =>{
  console.info(`gaid = ${Config.gaId}`)
  ReactGA.initialize(Config.gaId, {
    gaOptions: {
      debug_mode: true,
    },
    gtagOptions: {
      debug_mode: true,
    },
  });
}

export const logBrush = ( brushNumber: number )=>{
  const category = "UX"
  const action = "Brush_Choice"
  const label = brushNames[brushNumber] || "Not defined"
  console.log("GA event:", category, ":", action, ":", label);
  ReactGA.event({
      category: `${category}`,
      action: `${action}`,
      label: `${label}`,
      value: 1
  });
}

export const logSave = (is_public: string)=>{
  const category = "UX"
  const action = "Art_Save"
  const label = is_public
  console.log("GA event:", category, ":", action, ":", label);
  ReactGA.event({
      category: `${category}`,
      action: `${action}`,
      label: `${label}`,
      value: 1
  });
}


export const logDownload = ( isLoggedIn: boolean )=>{
  const category = "UX"
  const action = "Art_Download"
  const label = `${isLoggedIn?"LoggedIn" : "Anonymouse"}`
  console.log("GA event:", category, ":", action, ":", label);
  ReactGA.event({
      category: `${category}`,
      action: `${action}`,
      label: `${label}`,
      value: 1
  });
}